module.exports = __webpack_public_path__ + "static/media/fan3_lamp1.f9d42fa5.gif";